"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var chatMessage_1 = __importDefault(require("./chatMessage"));
var userChatMessageEditor_1 = __importDefault(require("./userChatMessageEditor"));
var ai_tutor_module_scss_1 = __importDefault(require("./ai-tutor.module.scss"));
var warningModal_1 = __importDefault(require("./warningModal"));
/**
 * Renders the AI Tutor main chat workspace component.
 */
var ChatWorkspace = function () {
    var storedMessages = (0, react_redux_1.useSelector)(function (state) { return state.aiTutor.chatMessages; });
    var isWaitingForChatResponse = (0, react_redux_1.useSelector)(function (state) { return state.aiTutor.isWaitingForChatResponse; });
    var showWaitingAnimation = function () {
        if (isWaitingForChatResponse) {
            return (react_1.default.createElement("img", { src: "/blockly/media/aichat/typing-animation.gif", alt: 'Waiting for response', className: ai_tutor_module_scss_1.default.waitingForResponse }));
        }
    };
    return (react_1.default.createElement("div", { id: "chat-workspace-area", className: ai_tutor_module_scss_1.default.chatWorkspace },
        react_1.default.createElement(warningModal_1.default, null),
        react_1.default.createElement("div", { id: "chat-workspace-conversation", className: ai_tutor_module_scss_1.default.conversationArea },
            storedMessages.map(function (message) { return (react_1.default.createElement(chatMessage_1.default, { message: message, key: message.id })); }),
            showWaitingAnimation()),
        react_1.default.createElement("div", { id: "chat-workspace-editor", className: ai_tutor_module_scss_1.default.userChatMessageEditor },
            react_1.default.createElement(userChatMessageEditor_1.default, null))));
};
exports.default = ChatWorkspace;
